/** @var jQuery */

jQuery(document).ready(function ($) {
    const body_classnames = document.body.className;
    var site_header = $("header.site-header");

    // Simple Lightbox default settings
    if (typeof SimpleLightbox !== "undefined" && typeof simple_lightbox_defaults !== "undefined") {
        SimpleLightbox.defaults.closeBtnCaption = simple_lightbox_defaults.close;
        SimpleLightbox.defaults.nextBtnCaption = simple_lightbox_defaults.next;
        SimpleLightbox.defaults.prevBtnCaption = simple_lightbox_defaults.prev;
        SimpleLightbox.defaults.loadingCaption = simple_lightbox_defaults.loading;
    }

    /**
     * Scrolls smoothly to given element.
     * @param selector
     * @param offset
     */
    var scroll_to_element = function (selector, offset) {
        offset = offset || 0;
        var scroll_to = (selector.offset().top - 150 - offset);

        if (scroll_to < 0) {
            scroll_to = 0;
        }

        $("html, body").animate({scrollTop: scroll_to}, 500);
    };


    // Automatically scroll to element when page loads.
    if (location.hash) {
        var element = document.getElementById(location.hash.substring(1));

        if (element) {
            scroll_to_element($(element), 0);
        }

    }

    // Scroll to element placed on the same page after anchor click.
    $("a[href^='#']").on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();

        var target_hash = $(event.currentTarget).attr("href");
        var target      = $(target_hash);

        if (target.length === 0) {
            return;
        }

        scroll_to_element(target, 0);
    });


    // Scroll down arrow.
    (function () {
        var arrow = $("#scroll-down-arrow");

        // Show on every page except the homepage.
        if (!document.body.classList.contains("home")) {
            arrow.addClass("active");
        }

        // On click.
        arrow.on("click", function () {
            var new_scroll = (!arrow.hasClass("reversed"))
                ? ($(window).scrollTop() + Math.round($(window).height() * 0.75))
                : 0;

            $("html, body").animate({scrollTop: new_scroll}, 500);
        });

        // Reverse arrow when scrolled to bottom.
        $(window).on("scroll", function () {
            var required_scroll_top = (
                $(document).height() // Page height.
                - $(window).height() // Viewport height.
                - 50                 // Tolerance.
            );

            if ($(window).scrollTop() >= required_scroll_top) {
                arrow.addClass("reversed");
            } else {
                arrow.removeClass("reversed");
            }
        });
    })();


    // Configure lightbox.
    if (typeof lightbox !== 'undefined') {
        lightbox.option({
            'resizeDuration': 500,
            'albumLabel' : 'Obrázek %1 / %2'
        });
    }


    // Sticky header.
	$(window).on("scroll", function () {
        if ($(window).scrollTop() > 0) {
            site_header.addClass("sticky");
        } else {
            site_header.removeClass("sticky");
        }
    });
	
	setTimeout(function () {
        if ($(window).scrollTop() > 0 && !site_header.hasClass("sticky")) {
            site_header.addClass("sticky");
        }
    }, 50);

    // Main navigation.
    (function () {
        var site_main_menu = site_header.find(".site-menu");
        var site_hamburger = site_header.find(".site-hamburger");

        site_hamburger.on("click", function () {
           site_main_menu.toggleClass("-active");
           site_hamburger.toggleClass("-active");
        });
    })();

    // Search form.
    (function () {
        var site_search_icon = site_header.find(".site-search-icon");
        var site_search_form = site_header.find(".site-search-form");

        site_search_icon.on("click", function () {
           site_search_form.toggleClass("-active");
        });
    })();

    // Language menu.
    (function () {
        var site_language        = site_header.find(".site-language");
        var site_language_actual = site_language.find(".site-language-actual");

        site_language_actual.on("click", function () {
            site_language.toggleClass("-active");
        });
    })();


    // Homepage.
    (function () {
        if (!document.body.classList.contains("home")) {
            return;
        }


        // Hero carousel initialization.
        var hero_slides_wrapper = $("#homepage-hero-slides");

        if (hero_slides_wrapper.length === 0) {
            return;
        }

        var hero_prev_control = $("#homepage-hero-arrow-prev");
        var hero_next_control = $("#homepage-hero-arrow-next");

        hero_slides_wrapper.owlCarousel({
            items: 1,
            loop: false,
            rewind: true,
            autoplay: true,
            autoplayTimeout: 6000,
            autoplayHoverPause: true,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
            nav: true,
            navContainer: "#homepage-hero-arrows",
            navText: [hero_prev_control, hero_next_control],
            dots: true,
            dotsContainer: "#homepage-hero-dots"
        });

        // Hero SimpleLightbox for YouTube videos.
        hero_slides_wrapper.find(".homepage-hero-slide-media .video-thumbnail").simpleLightbox();


        // Posts slider.
        var posts_wrapper = $("#homepage-posts-posts");

        if (posts_wrapper.length === 0) {
            return;
        }

        var posts_prev_control = $("#homepage-posts-arrow-prev");
        var posts_next_control = $("#homepage-posts-arrow-next");

        posts_wrapper.owlCarousel({
            items: 1,
            margin: 35,
            loop: false,
            rewind: true,
            mouseDrag: true,
            touchDrag: true,
            pullDrag: true,
            freeDrag: false,
            nav: true,
            navContainer: "#homepage-posts-arrows",
            navText: [posts_prev_control, posts_next_control],
            dots: false,
            responsive: {
                768: {
                    items: 2
                },
                1551: {
                    items: 3
                }
            }
        });
    })();


    // Service page.
    (function () {
        if (!document.body.classList.contains("page-template-template-service")) {
            return;
        }

        $(".service-videos .service-videos-col .service-video-item").simpleLightbox();

        $(".service-introduction .container .col-60 .btn").on("click", function() {
            var this_btn = $(this);

            // Don't continue on already activated button.
            if (this_btn.hasClass("-active")) {
                return;
            }

            // Get ID of section we will show.
            var target                  = this_btn.data("target");
            var section                 = this_btn.parent();
            var target_section          = section.find("#" + target);

            console.log(target);
            console.log(target_section);

            // Don't continue if no target section found.
            if (target_section.length <= 0) {
                return;
            }

            var active_section = target_section.siblings(".-active");

            if (active_section.length > 0) {

                // Hide active setion, then show targeted section.
                active_section.slideUp(400, function() {
                    active_section.removeClass("-active");
                    target_section.addClass("-active");
                    target_section.slideDown(400);
                    scroll_to_element(target_section, 150);
                });

            } else {

                //Show targeted section.
                target_section.addClass("-active");
                target_section.slideDown(400);
                scroll_to_element(target_section, 150);

            }

            // Manage active classes.
            this_btn.siblings().removeClass("-active");
            this_btn.addClass("-active");

        });
    })();


    // Machine (or Offer) - single.
    (function () {
        if (
            !document.body.classList.contains("single-trimill_machine")
            && !document.body.classList.contains("single-trimill_offer")
        ) {
            return;
        }

        $(".machine-photogallery-container .machine-photogallery-item").simpleLightbox();
        $(".machine-videogallery-container .machine-videogallery-item").simpleLightbox();

    })();

    // Machine (or Offer) - single or archive or taxonomy.
    (function () {
        
        if (
            !document.body.classList.contains("single-trimill_machine")
            && !document.body.classList.contains("single-trimill_offer")
            && !document.body.classList.contains("post-type-archive-trimill_machine")
            && !document.body.classList.contains("tax-trimill_category")
        ) {
            return;
        }

        $(".machine-footer .machine-footer-btns .btn").on("click", function() {
            var this_btn = $(this);

            // Don't continue on already activated button.
            if (this_btn.hasClass("-active")) {
                return;
            }

            // Get ID of section we will show.
            var target                  = this_btn.data("target");
            var machine_footer_sections = this_btn.closest(".machine-footer").find(".machine-footer-sections");
            var target_section          = machine_footer_sections.find("#" + target);

            // Don't continue if no target section found.
            if (target_section.length <= 0) {
                return;
            }

            var active_section = target_section.siblings(".-active");

            if (active_section.length > 0) {

                // Hide active setion, then show targeted section.
                active_section.slideUp(400, function() {
                    active_section.removeClass("-active");
                    target_section.addClass("-active");
                    target_section.slideDown(400);
                    scroll_to_element(target_section, 150);
                });

            } else {

                //Show targeted section.
                target_section.addClass("-active");
                target_section.slideDown(400);
                scroll_to_element(target_section, 150);

            }

            // Manage active classes.
            this_btn.siblings().removeClass("-active");
            this_btn.addClass("-active");

        });

        // If there is a form-specific hash in the URL, show the form.
        if (["#offer-form", "#compare-form"].indexOf(location.hash) !== -1) {
            var target_section = $(location.hash);

            if (target_section.length > 0) {
                target_section.addClass("-active");
                target_section.slideDown(400);
                scroll_to_element(target_section, 150);
            }
        }

    })();

    // Applications - archive.
    (function () {
        if (!document.body.classList.contains("post-type-archive-trimill_application")) {
            return;
        }

        $(".applications-list-item-links a.video-thumbnail").simpleLightbox();
        $(".applications-list-item-content-photogallery > li > a").simpleLightbox();
    })();

    // About us - template
    (function () {
        if (!document.body.classList.contains("page-template-template-about-us")) {
            return;
        }

        var image_slider = $(".-about-us-block .about-us-slider");
        if (image_slider.length > 0) {
            image_slider.owlCarousel({
                items: 1,
                margin: 0,
                loop: false,
                rewind: false,
                mouseDrag: false,
                touchDrag: false,
                pullDrag: false,
                freeDrag: false,
                nav: false,
                dots: true,
            });

            image_slider.find(".about-us-slider-item").simpleLightbox();
        }

        $(".-about-us-block .video-thumbnail").simpleLightbox();

        var horizontal_timeline = $(".horizontal-timeline .timeline-carousel.owl-carousel");

        if (horizontal_timeline.length <= 0) {
            return;
        }

        var timeline_prev_btn = $("#homepage-hero-arrow-prev");
        var timeline_next_btn = $("#homepage-hero-arrow-next");

        horizontal_timeline.owlCarousel({
            items: 1,
            margin: 0,
            loop: false,
            rewind: false,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
            nav: true,
            navContainer: "#horizontal-timeline-arrows",
            navText: [timeline_prev_btn, timeline_next_btn],
            dots: false,
            responsive: {
                768: {
                    items: 2
                },
                1331: {
                    items: 3
                }
            }
        });

        synchronize_timeline_items_height(horizontal_timeline);
        $(window).on("resize", function() {
            synchronize_timeline_items_height(horizontal_timeline);
        });

        function synchronize_timeline_items_height(horizontal_timeline) {
            var items = horizontal_timeline.find(".timeline-item");
		
            if (items.length <= 1) {
                return;
            }
            
            items.each(function() {
                $(this).css("height", "");
            });

            var biggest_height = Math.max.apply(null, $(items).map(function () {
                return $(this).outerHeight();
            }).get());

            items.each(function() {
                $(this).css("height", biggest_height);
            });

            var horizontal_arrows = horizontal_timeline.closest(".horizontal-timeline-container").find(".timeline-arrow");
            
            if (horizontal_arrows.length <= 0) {
                return;
            }

            horizontal_arrows.each(function() {
                $(this).css("top", "");
            });
            
            horizontal_arrows.each(function() {
                $(this).css("top", (biggest_height - 1));
            });
            
        }

    })();


    // Flexible content.
    (function () {
        if (!document.body.classList.contains("page-template-template-flex")) {
            return;
        }

        // Photogallery & videos.
        $(".video-thumbnail").simpleLightbox();
        $(".photogallery > li > .photogallery-photo").simpleLightbox();
        $(".map-image").each(function() {
            $(this).find("a").simpleLightbox();
        });

        /**
         * initMap
         *
         * Renders a Google Map onto the selected jQuery element
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   {jQuery} $el The jQuery element.
         * @return  object The map instance.
         */
        var initMap = function($el) {
            // Find marker elements within map.
            var $markers = $el.find('.marker');

            // Create gerenic map.
            var mapArgs = {
                zoom        : $el.data('zoom') || 16,
                mapTypeId   : google.maps.MapTypeId.ROADMAP
            };
            var map = new google.maps.Map( $el[0], mapArgs );

            // Add markers.
            map.markers = [];
            $markers.each(function(){
                initMarker( $(this), map );
            });

            // Center map based on markers.
            centerMap( map );

            // Return map instance.
            return map;
        }

        /**
         * initMarker
         *
         * Creates a marker for the given jQuery element and map.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   {jQuery} $marker The jQuery element.
         * @param   {object} map     The map instance.
         * @return  object The marker instance.
         */
        var initMarker = function($marker, map) {

            // Get position from marker.
            var lat = $marker.data('lat');
            var lng = $marker.data('lng');
            var latLng = {
                lat: parseFloat( lat ),
                lng: parseFloat( lng )
            };

            // Create marker instance.
            var marker = new google.maps.Marker({
                position : latLng,
                map: map
            });

            // Append to reference for later use.
            map.markers.push( marker );

            // If marker contains HTML, add it to an infoWindow.
            if( $marker.html() ){

                // Create info window.
                var infowindow = new google.maps.InfoWindow({
                    content: $marker.html()
                });

                // Show info window when marker is clicked.
                google.maps.event.addListener(marker, 'click', function() {
                    infowindow.open( map, marker );
                });
            }
        }

        /**
         * centerMap
         *
         * Centers the map showing all markers in view.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   {object} map The map instance.
         * @return  void
         */
        var centerMap = function(map) {

            // Create map boundaries from all map markers.
            var bounds = new google.maps.LatLngBounds();
            map.markers.forEach(function( marker ){
                bounds.extend({
                    lat: marker.position.lat(),
                    lng: marker.position.lng()
                });
            });

            // Case: Single marker.
            if( map.markers.length === 1 ){
                map.setCenter( bounds.getCenter() );

                // Case: Multiple markers.
            } else{
                map.fitBounds( bounds );
            }
        }

        // Render maps on page load.
        $('.acf-map').each(function() {
            var map = initMap($(this));
        });

    })();


    // Event.
    (function () {
        if (!document.body.classList.contains("page-template-template-event")) {
            return;
        }

        $(".video-thumbnail").simpleLightbox();
    })();


    // Slide content.
    (function () {

        var slide_columns = $(".slide-column");
        if (slide_columns.length < 1) return;

        var slide_column_btns = slide_columns.find(".slide-column-btn");

        slide_column_btns.on("click", function() {
            $(this).closest(".slide-column").find(".slide-content").slideToggle();
        });

    })();

    // Customer zone.
    (() => {
        if (!["page-template-template-customer-zone-landing"].some(css_class => body_classnames.includes(css_class))) return;
        
        const form = document.querySelector("#loginform");

        if (!form) return;

        // Show error message if login failed.
        const url_hashes = window.location.hash.split("#");
        if (url_hashes.includes("login_failed")) {
            const template = document.querySelector("#customer-zone-login-fail");

            if (template) {
                const template_content = template.content.cloneNode(true);
                form.prepend(template_content);
            }
        }

        form.addEventListener("submit", (event) => {

            // https://javascript.info/formdata
            const form_data = new FormData(form);

            const values = [
                form_data.get("log") ?? "",
                form_data.get("pwd") ?? "",
            ];

            // Prevent form submit if all of our values are empty.
            if (!values.every(value => value.trim().length > 0)) {
                event.preventDefault();
            }

        });

    })();

    // MyTrimill Service
    (function() {
        if (!["mytrimill-service"].some(css_class => body_classnames.includes(css_class))) return;
        
        const main = document.querySelector(".site-main");
        let timer = setTimeout(mytrimill_fix_site_main, 400);
    
        $(window).on("resize", function() {
            clearTimeout(timer);
            timer = setTimeout(mytrimill_fix_site_main, 400);
        });

        $(window).on("scroll", function () {
            if ($(window).scrollTop() <= 0) {
                clearTimeout(timer);
                timer = setTimeout(mytrimill_fix_site_main, 400);
            }
        });

        function mytrimill_fix_site_main() {
            if (!main) return;

            if (!window.matchMedia("only screen and (max-width: 1023px) and (min-width: 0)").matches) {
                main.style.paddingTop = "";
                return;
            }

            const site_header_height = site_header.outerHeight();
            main.style.paddingTop = `${site_header_height}px`;
        }

        // File input clone.
        const clone_btn = document.querySelector("#file-input-clone-btn");
        if (!clone_btn) return;

        const template = document.querySelector("#file-input-template");
        const file_inputs_container = document.querySelector(".file-inputs-container");
        let files_count = 1;

        clone_btn.addEventListener("click", function(e) {
            const max_inputs = clone_btn.dataset.max || 5;
            if (files_count >= max_inputs) return;

            const item = template.content.cloneNode(true);
            
            const label = item.querySelector('label');
            const label_for = label.getAttribute("for");
            label.setAttribute("for", label_for.replace("(id)", files_count));

            const input = item.querySelector('input');
            const input_id = input.getAttribute("id");
            input.setAttribute("id", input_id.replace("(id)", files_count));

            files_count++;
            file_inputs_container.insertBefore(item, clone_btn);
        });

        $(document).on("change", ".file-input-item input[type=file]", function(e) {
            const this_el = $(this);
            const files_count = this_el[0].files.length;
            if (files_count > 0) {
                const filename = this_el[0].files[0].name;
                this_el.prev().text(filename);
            }
        });
        
    })();

});
